import GeneralTableComponent from 'components/GeneralCRUDComponent/GeneralTableComponent/GeneralTableComponent';
import { RequestStatus } from 'components/GeneralFormView/types';
import { translate } from 'helperFunctions/translation';
import {
  inject,
  observer,
    useObserver,
  } from 'mobx-react';
import { WheelEventsGroup } from 'mobx-store/storeInterfaces/wheelFortuneInterface';
import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import AddEditEventModal from '../addEditEventsGroupsScreen';
import {
  EventsProps,
} from '../types';
  
  const WheelEventsGroupsScreen: React.FC<EventsProps> = observer(inject('wheelFortuneStore')((props: EventsProps) => {
    const history = useHistory();
    const [modalOpen, setModalOpen] = useState(false);
    const [selectedGroup , setSelectedGroup] = useState<WheelEventsGroup>();

    const {
      wheelFortuneStore,
    } = props;

    useEffect(() => { onInit() } , []);
    useEffect(() => {
      return () => {
        setModalOpen(true);
      };
    }, [selectedGroup]);

    const onInit = async () => {
      await wheelFortuneStore.getWheelEventsGroups();
    }

    const addWheelEventGroup  = () => {
      setSelectedGroup({
        id: -1,
        eventGroupTitle: ''
      });
    };
    const editWheelGroup = async (index: number, key: string) => {
      const eventGroup = wheelFortuneStore.eventsGroups[index];
      setSelectedGroup({
        ...eventGroup
      });
    }

    const addOrEditGroupForm = async (values: WheelEventsGroup) => {
      if(values.id > -1) {
        await wheelFortuneStore.updateEventsGroup(values.id, values);
      } else {
        await wheelFortuneStore.addEventsGroup(values);
      }
      setModalOpen(false);
      await wheelFortuneStore.getWheelEventsGroups();
    }

    const EventsGroupTable = (props: {state: RequestStatus}) => {
      return(
        <GeneralTableComponent
          emptyMessage={translate('settingsListNoSettingsMessage', {
          })}
          title={'Wheel of fortune events groups'}
          tableHeader={[
            {
              title: "title"
            },
            {
              title: 'Edit'
            }
          ]}
          tableData={
            wheelFortuneStore.eventsGroups.map(group => {
              return {
                ...group,
                edit: 'edit'
              }
            })
          }
          tableCellTypes={[
            {
             key: 'eventGroupTitle',
             cellType: 'Text' 
            },
            {
              key: 'edit',
              cellType: 'Button',
              onClick: editWheelGroup
            }
          ]}
          loadingStatus={[
            props.state
          ]}
          addButton={{
            title: 'Add Wheel event group',
            onAdd: addWheelEventGroup
          }}
      />
      )
    };
    return useObserver(() => (
      <>
      <AddEditEventModal
        wheelEventsGroup={selectedGroup}
        open={modalOpen}
        onClose={() => setModalOpen(false)}
        onSaveForm={addOrEditGroupForm}
        loadingState={wheelFortuneStore.createAndUpdateStatus}
      />
      <EventsGroupTable state={wheelFortuneStore.status} />
      </>
    ));
  }));
  
  export default WheelEventsGroupsScreen;
  